import { render, staticRenderFns } from "./FormatsBase.vue?vue&type=template&id=2c5bc140"
import script from "./FormatsBase.vue?vue&type=script&lang=js"
export * from "./FormatsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports